import styled, { keyframes } from 'styled-components';

export const FadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(2%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const Content = styled.div`
  opacity: 0;
  animation: ${FadeUp} 0.6s ease 0.1s forwards;
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  justify-content: start;
  grid-column-gap: 80px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    padding-bottom: 24px;
    height: 100vh;
    ${Content} {
      padding: 16px;
      height: 100%;
      overflow: scroll;
    }
  }
`;
